import React from "react";
import * as faceapi from "face-api.js";
import { markAttendance, getAttendance } from "./utils";

const MarkAttendance = ({ videoRef, users, refreshAttendance }) => {

  const captureFace = async () => {
    if (!videoRef.current || videoRef.current.readyState !== 4) {
      alert("Camera not ready");
      return null;
    }

    return await faceapi
      .detectSingleFace(
        videoRef.current,
        new faceapi.TinyFaceDetectorOptions()
      )
      .withFaceLandmarks()
      .withFaceDescriptor();
  };

  const markUserAttendance = async () => {
    if (users.length === 0) {
      return alert("No users registered ❌");
    }

    const face = await captureFace();
    if (!face) return alert("Face not detected ❌");

    const labeledDescriptors = users.map(
      (user) =>
        new faceapi.LabeledFaceDescriptors(user.name, [
          new Float32Array(user.descriptor)
        ])
    );

    const matcher = new faceapi.FaceMatcher(labeledDescriptors, 0.5);
    const match = matcher.findBestMatch(face.descriptor);

    if (match.label === "unknown") {
      alert("❌ Not recognized");
    } else {
      markAttendance(match.label);
      refreshAttendance();
      alert(`✅ ${match.label} marked`);
    }
  };

  return (
    <div className="mark-section">
      <button onClick={markUserAttendance} className="button" type="submit">
        Mark Attendance
      </button>
    </div>
  );
};

export default MarkAttendance;